
import React, { Component } from 'react'
import axios from 'axios'
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { NotificationContainer, NotificationManager} from 'react-notifications'
import 'react-notifications/lib/notifications.css';
class LoginPage extends Component {
	constructor(props) {
		super(props)

		this.state = {
			username: '',
			password: ''
			
		}
	}

	changeHandler = e => {
		this.setState({ [e.target.name]: e.target.value })
	}



	submitHandler = e => {
		e.preventDefault()
		console.log(this.state)
		axios
			.post('https://shoppee-clone.herokuapp.com/login/', this.state)
			.then(response => {
				console.log(response)
                const token = response.data.token;
                const loggedInUserID = response.data.user_id;
                const type = response.data.type;
                localStorage.setItem("token", token);
                localStorage.setItem("loggedInUserID", loggedInUserID);
                localStorage.setItem("type", type);

              
                window.location.replace("/");
                
			})
			.catch(error => {
        NotificationManager.error('Unsuccessful login');
				console.log(error)
			})
	}
  onFormSubmit(event)
  {
    event.preventDefault();
      window.location.replace("/");
      
  }
 registerpage(event)
  {
    event.preventDefault();
      window.location.replace("/Register");
      
  }
	render() {
		const { username, password } = this.state
		return (
      <div className="rounded d-flex justify-content-center " style={{marginTop: '100px'}}>
      <div className="col-md-4 col-sm-12 shadow-lg p-5 bg-light">
        
            <form onSubmit={this.submitHandler}>
              <div className="p-4">
                 
                  <div className="input-group mb-3 justify-content-center">
                     <span className="input-group-text bg-primary"><i className="bi bi-person-plus-fill text-black" /></span>
                    <input
                        type="text"
                        name="username"
                        placeholder="Username" 
                        id="username" 
                         
                        value={username}
                        onChange={this.changeHandler}
                    />
                  </div>
                <div className="input-group mb-3 justify-content-center">
                  <span className="input-group-text bg-primary"><i className="bi bi-key-fill text-black" /></span>
                  <input
                        type="password"
                        name="password"
                        placeholder="Password" 
                        id="password" 
                        
                        value={password}
                        onChange={this.changeHandler}
                    />
                  </div>
                <div className="pt-2 d-flex flex-column">
                  <button className="btn btn-primary text-center mt-2" type="submit" id="login">
                    Login
                  </button>
                  
                  <p class="text-center text-dark">OR</p>
     
                </div>
              </div>
            </form>
           
              <form onSubmit={this.registerpage}>
              <div class="d-flex flex-column justify-content-center">
                 <button class="btn btn-secondary text-center mt-2" id="register" >
          Register
        </button> </div></form>
       <form onSubmit={this.onFormSubmit}>
       <div class="d-flex flex-column justify-content-center">
       <button class="btn btn-primary text-center mt-2" id="continue" >
          Continue as guest
        </button></div>
       </form>
        
      </div>
      <p class="d-flex justify-content-center text-center text-danger" id="error-login"></p>
      <NotificationContainer/>
          </div>
          
		)
	}
}

export default LoginPage

/* <div>
            <form onSubmit={this.submitHandler}>
              <div className="p-4">
                <div className="input-group mb-3">
                  <span className="input-group-text bg-primary"><i className="bi bi-person-plus-fill text-white" /></span>
                  <input
                        type="text"
                        name="username"
                        value={username}
                        onChange={this.changeHandler}
                    />
                </div>
                <div className="input-group mb-3">
                  <span className="input-group-text bg-primary"><i className="bi bi-key-fill text-white" /></span>
                 <input
                        type="text"
                        name="password"
                        value={password}
                        onChange={this.changeHandler}
                    />
                </div>
                <div className="pt-2 d-flex flex-column">
                  <button className="btn btn-primary text-center mt-2" type="submit" id="login">
                    Login
                  </button>
                </div>
              </div>
            </form>
          </div> */

  